/**
 * THE theme register — one light/dark contract for every app in the monorepo.
 *
 * This used to live in `apps/console/src/hooks/`, where its own docstring
 * claimed "same contract as apps/internal". It was not: console defaulted to
 * LIGHT behind a versioned migration while internal's FOUC script defaulted to
 * DARK and had no hook, no toggle, and no way for a user to change it. Two
 * staff tools on one design system rendered in two different themes. Moving the
 * register here is what makes the claim true.
 *
 * MUST stay in lockstep with each app's `index.html` FOUC script — that script
 * paints the class before React mounts, so a disagreement is a visible flash of
 * the wrong theme on every cold load. Both apps ship the same script.
 */

export type Theme = 'light' | 'dark';

export const THEME_STORAGE_KEY = 'knitknot-theme';
export const THEME_MIGRATION_KEY = 'knitknot-theme-default-version';
export const THEME_DEFAULT_VERSION = 'light-v2';

/**
 * Move every pre-v2 session to the light default exactly once. Once the
 * migration marker is current, an explicit dark selection is preserved.
 */
export function resolveTheme(
  storedTheme: string | null | undefined,
  migratedVersion: string | null | undefined,
): Theme {
  if (migratedVersion !== THEME_DEFAULT_VERSION) return 'light';
  return storedTheme === 'dark' ? 'dark' : 'light';
}
